import {namesOf} from '@/utils/names';

// Roles synced to workfix-backend with department couplings.
// Mirrors User::ADMIN_LIKE_ROLES on the Laravel side.
const ADMIN_LIKE_ROLES = ['admin', 'account_manager', 'location_manager'];

const HOUR_APP_ROLES_REQUIRING_COMPANY = ['client'];

// Firestore stores user.departments as [{name, ...}, ...]; the backend expects
// an array of plain strings.
export function normalizeDepartmentNames(departments) {
    return namesOf(departments);
}

function pickAdminLikeRole(rolesByDept) {
    return Object.values(rolesByDept || {}).find(r => ADMIN_LIKE_ROLES.includes(r)) || null;
}

export function buildHourAppUserPayload(user) {
    const role = pickAdminLikeRole(user.roles);
    if (!role) return null;

    const fullName = user.name || `${user.firstname || ''} ${user.lastname || ''}`.trim();
    return {
        name: fullName,
        email: user.email,
        role,
        locale: user.locale || 'nl',
        firebaseId: user.id || user.uid,
        departments: user.departments,
    };
}

export function hourAppRoleRequiresCompany(role) {
    return HOUR_APP_ROLES_REQUIRING_COMPANY.includes(role);
}

export function buildNewUserHourAppPayload({user, hourAppRole, firebaseId, company}) {
    if (!hourAppRole) return null;

    return {
        name: user.firstname + ' ' + user.lastname,
        email: user.email,
        password: user.password,
        role: hourAppRole,
        locale: 'en',
        departments: user.departments,
        firebaseId,
        ...(company ? {orgFirebaseId: company.id, organization_name: company.name} : {}),
    };
}
